export const expertise = [
  {
    name: "Appliances",
    icon: "tv"
  },
  {
    name: "Doors",
    icon: "door-open"
  },
  {
    name: "Electrical",
    icon: "lightbulb"
  },
  {
    name: "Floor",
    icon: "columns-gap"
  },
  {
    name: "Contractors",
    icon: "person-badge"
  },
  {
    name: "Handyman",
    icon: "tools"
  },
  {
    name: "Glass",
    icon: "window-sidebar"
  },
  {
    name: "HVAC",
    icon: "thermometer-snow"
  },
  {
    name: "Landscaping",
    icon: "tree"
  },
  { 
    name: "Locksmiths",
    icon: "key"
  },
  {
    name: "Painters",
    icon: "paint-bucket"
  },
  {
    name: "Pest-Control",
    icon: "bug"
  },
  {
    name: "Plumbing",
    icon: "wrench-adjustable"
  },
  {
    name: "Renovation Services",
    icon: "hammer"
  },
  {
    name: "Roofing",
    icon: "umbrella"
  },
  {
    name: "Concrete",
    icon: "bricks"
  },
  {
    name: "Carpenters",
    icon: "hammer"
  },
]